import React, { useEffect, useState } from "react";
import './HadithContainer.css';
import axios from "axios";
import { Pagination } from '@mui/material';

// دالة لإزالة التشكيل من النصوص
const removeDiacritics = (text) => {
    return text.replace(/[\u064B-\u065F\u0610-\u061A\u06D6-\u06ED]/g, '');
};

function HadithContainer() {
    const [hadithcontainer, setHadithContainer] = useState([]);
    const [filteredHadiths, setFilteredHadiths] = useState([]); // لتخزين الأحاديث المصفاة
    const [searchText, setSearchText] = useState(""); // حالة لنص البحث
    const [page, setPage] = useState("1");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `https://hadis-api-id.vercel.app/hadith/abu-dawud?page=${page}&limit=25`
                );
                setHadithContainer(response.data.items);
                setFilteredHadiths(response.data.items); // تحديث الأحاديث المصفاة أيضًا
            } catch (error) {
                console.error("Error fetching Hadith details:", error);
            }
        };
        fetchData();
    }, [page]);

    useEffect(() => {
        // تصفية الأحاديث بناءً على نص البحث
        const normalizedSearchText = removeDiacritics(searchText); // إزالة التشكيل من نص البحث
        if (searchText) {
            setFilteredHadiths(
                hadithcontainer.filter(hadith =>
                    removeDiacritics(hadith.arab).includes(normalizedSearchText)
                )
            );
        } else {
            setFilteredHadiths(hadithcontainer); // إذا لم يكن هناك نص بحث، عرض جميع الأحاديث
        }
    }, [searchText, hadithcontainer,page]);

    return (
        <>
            <div className="HadithContainer">
                <h2>كل الاحاديث</h2>
                <input
                    style={{ width: "88.5%", textAlign: "center", margin: "auto",fontWeight:"bold",fontFamily:"sans-serif" }}
                    type="text"
                    className="form-control"
                    placeholder="ادخل اي كلمه موجوده في الحديث التي تريده"
                    aria-label="Search"
                    value={searchText} // ربط النص المكتوب بالحالة
                    onChange={(e) => setSearchText(e.target.value)} // تحديث نص البحث
                />
                <div className="hadithes">
                    {filteredHadiths.map((hadith, index) => {
                        return (
                            <div key={index} className="hadith1">
                                {hadith.arab}
                            </div>
                        );
                    })}
                </div>
                <div className="pagination">
                    <Pagination
                        onChange={(e, value) => setPage(value)} // تحديث الصفحة
                        count={177}
                        variant="outlined"
                        color="secondary"
                    />
                </div>
            </div>
        </>
    );
}

export default HadithContainer;
